import React, { createContext, useContext, useState, Dispatch, SetStateAction } from 'react';

type AuthFormValues = {
  email: string;
  password: string;
};

type AuthContextType = {
  authValues: AuthFormValues;
  setAuthValues: Dispatch<SetStateAction<AuthFormValues>>;
};

const defaultAuthValues: AuthFormValues = {
  email: '',
  password: '',
};

export const AuthFormContext = createContext<AuthContextType>({} as AuthContextType);

export const useAuthForm = () => useContext(AuthFormContext);

export const AuthFormProvider = ({ children }: { children: React.ReactNode }) => {
  const [authValues, setAuthValues] = useState<AuthFormValues>(defaultAuthValues);

  return (
    <AuthFormContext.Provider value={{ authValues, setAuthValues }}>
      {children}
    </AuthFormContext.Provider>
  );
};
